@if (patientAttachment.duplicatePatientAttachment) {
  <section class="row mt-2">
    <div class="col-12">
      This document was marked as a duplicate of
      <a class="phi" routerLink="/capture-admin/consult-notes/{{ patientAttachment.duplicatePatientAttachment.id }}"
        target="_blank"
        title="Open duplicate consult note in new tab">{{
        patientAttachment.duplicatePatientAttachment.displayName
      }}</a>.
      ({{ patientAttachment.duplicatePatientAttachmentLcsRatio }}% Similarity)
    </div>
  </section>
}
